import { sendWebsocketMessage } from '../../../../../../App';

export function removeTradePlan(tradePlanId){
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'cancelTradePlan',
    value: {}
  };
  sendWebsocketMessage(msg);
}
